import React, { useEffect, useState } from "react";
import "../../../styles/navbar.css";
import notification from "../../../assets/images/notification.svg";
import profile from "../../../assets/images/profile.png";
import logout from "../../../assets/images/logout.svg";
import pwcLoginLogo from "../../../assets/images/logo-title.png";
import { withRouter } from "react-router-dom";
import { Tooltip } from "@appkit4/react-components/tooltip";
import PropTypes from "prop-types";
import APIService from "../../../services/apiAxiosService.js";
import useHttp from "../../../hooks/useHttp.js"

function Navabar(props) {
  const [count, setCount] = useState("");
  const [profileData, setProfileData] = useState([]);
  const { sendRequest: notificationCountAPI } = useHttp();
  const { sendRequest: clearLoginSession } = useHttp();
  const { sendRequest: getProfileDataByUserId } = useHttp();

  const handleLogout = async () => {
    props.history.push("/");
    clearLoginSession(APIService.clearLoginSession({ userID: sessionStorage.getItem("userId")}), (result) => {
      
    });
    sessionStorage.removeItem("roleId");
    sessionStorage.removeItem("loggedIn");
    sessionStorage.removeItem("userId");
    sessionStorage.removeItem("orgId");
    sessionStorage.removeItem("jwtToken");
    sessionStorage.removeItem("refreshToken");
    sessionStorage.removeItem("idamLogin");
  };

  useEffect(() => {
    getNotificationCountData();
    getProfileData();
  }, []);

  const goToNotification = () => {
    props.history.push("/notifications");
  };

  const getNotificationCountData = async () => {
    await notificationCountAPI(
      APIService.getNotifcationsCount(),
      (res) => {
        setCount(res.MSG);
      }
    );
  };

  const getProfileData = async () => {
    let userID = {userId: Number(sessionStorage.getItem("userId"))}
    getProfileDataByUserId(APIService.getProfileDataByUserId(userID), (res) => {
        setProfileData(res?.MSG);
        sessionStorage.setItem("email", res.MSG[0]?.email_id);
        sessionStorage.setItem("org_name", res.MSG[0]?.org_name);
        sessionStorage.setItem("image", res.MSG[0]?.image);
        sessionStorage.setItem("username", res.MSG[0]?.user_name);
        sessionStorage.setItem("vendorId", res.MSG[0]?.vendorid);

    })
  };


  //    email_id: "analyst123@xyz.com"
  // org_name: "NTT"
  // role_name: "TPRM Analyst"
  // user_name: "analyst 1234"

  const profileHandler =
  profileData.length<=1 && profileData?.map((item) => {
      return (
        <div className="modifyTooltip">
          <span className="a-list-title">&nbsp;Welcome {item.user_name}</span>
          <span className="a-list-title">
            &nbsp; Organization: {item.org_name}
          </span>
          <span className="a-list-title">&nbsp; Role: {item.role_name}</span>
        </div>
      );
    });

  return (
    <div className="container-fluid">
      <nav className="navbar fixed-top navbar-expand-sm navbar-dark p-0 white-background ">
        <div className="row focus">
          <div className="ps-5">
            <img src={pwcLoginLogo} alt="" height="20px"></img>
          </div>
          {/* <div className="vertical-line-header"></div>
          <div className="pt-3">
            <p className="title-nav">TPRM</p>
          </div> */}
        </div>
        <div className="col-md-5 universal-search"></div>
          <div className="input-group ">
            {/* <div class="input-group-prepend">
      <span class="input-group-text pointer" id="basic-addon1"><img src={search} width="16px" alt="" height="16px" /></span>
      </div> */}
            {/* <input type="text" className="form-control" placeholder="Search" aria-label="Username" aria-describedby="basic-addon1"/> */}
            <div className="input-group-append">
              <div className="dropdown-menu">
                <a className="dropdown-item" href="#">
                  Action
                </a>
                <a className="dropdown-item" href="#">
                  Another action
                </a>
                <a className="dropdown-item" href="#">
                  Something else here
                </a>
                <div role="separator" className="dropdown-divider"></div>
                <a className="dropdown-item" href="#">
                  Separated link
                </a>
              </div>
            </div>
          </div>
        <div className="collapse navbar-collapse" id="navbarResponsive">
          <ul className="navbar-nav ml-auto float-end">
            {sessionStorage.getItem("roleId") !== "6" ? (
              <li className="nav-item focus mt-2 me-2" tabIndex="0">
                <span>
                  <img
                    src={notification}
                    width="21px"
                    alt=""
                    height="21px"
                    onClick={goToNotification}
                  />
                  {count && count.countvalue !== null ? (
                    <span className="notificationCount">
                      {count?.countvalue}
                    </span>
                  ) : (
                    <span className="notificationCount">0</span>
                  )}
                </span>
              </li>
            ) : null}
            {/* <li className="nav-item focus" tabIndex="0">
              <p className="nav-link" ><img src={time} width="21px" alt="" height="21px" /></p>
            </li> */}
            <Tooltip
              content={profileHandler}
              trigger="click"
              refClassName="a-account-info"
              className="a-account-options"
              tooltipTheme="light"
              clickToClose
              style={{ zIndex: 1500 }}
            >
              <li className="nav-item focus">
                <p className="nav-link">
                  <img src={profile} width="21px" alt="" height="21px" />
                </p>
              </li>
            </Tooltip>
            <li className="nav-item focus" onClick={handleLogout}>
              <p className="nav-link">
                <img src={logout} width="21px" alt="logout" height="21px" />
              </p>
            </li>
          </ul>
        </div>
      </nav>
    </div>
  );
}
Navabar.propTypes = {
  history: PropTypes.any
}
export default withRouter(Navabar);
